/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'

// Containers
const Full = () => import('@/containers/Full')

// Views
const Dashboard = () => import('@/views/Dashboard')

// Views - Articles
const ArticleSubmit = () => import('@/views/articles/Submit')
const ArticleNextStep = () => import('@/views/articles/NextStep')
const Articles = () => import('@/views/articles/Articles')
const ArticlesView = () => import('@/views/articles/View')

// Views - Editions
const Editions = () => import('@/views/editions/Editions')
const EditionOpen = () => import('@/views/editions/Open')
const EditionView = () => import('@/views/editions/EditionView')
const EditionEdit = () => import('@/views/editions/EditionEdit')
const IndexManagement = () => import('@/views/editions/IndexManagement')

// Views - Legislations
const LegislationsIndex = () => import('@/views/legislations/Index')
const LegislationsAdd = () => import('@/views/legislations/Add')
const LegislationsView = () => import('@/views/legislations/View')
const LegislationsEdit = () => import('@/views/legislations/Edit')

// Views - Users
const UsersIndex = () => import('@/views/users/Index')
const UsersAdd = () => import('@/views/users/Add')
const UsersView = () => import('@/views/users/View')
const UsersEdit = () => import('@/views/users/Edit')

// Views - Profiles
const ProfilesIndex = () => import('@/views/profiles/Index')
const ProfilesAdd = () => import('@/views/profiles/Add')
const ProfilesView = () => import('@/views/profiles/View')
const ProfilesEdit = () => import('@/views/profiles/Edit')
const ProfilesPermissions = () => import('@/views/profiles/Permissions')

// Views - Agencies
const AgenciesIndex = () => import('@/views/agencies/Index')
const AgenciesAdd = () => import('@/views/agencies/Add')
const AgenciesView = () => import('@/views/agencies/View')
const AgenciesEdit = () => import('@/views/agencies/Edit')

// Views - Categories
const CategoriesIndex = () => import('@/views/categories/Index')
const CategoriesAdd = () => import('@/views/categories/Add')
const CategoriesView = () => import('@/views/categories/View')
const CategoriesEdit = () => import('@/views/categories/Edit')

// Views - Categorias vs Redatores
const CategoriesEditorsIndex = () => import('@/views/categories/editors/Index')
const CategoriesEditorsAdd   = () => import('@/views/categories/editors/Add')
const CategoriesEditorsView  = () => import('@/views/categories/editors/View')
const CategoriesEditorsEdit  = () => import('@/views/categories/editors/Edit')

// Views - Categorias vs Conferentes
const CategoriesCheckersIndex = () => import('@/views/categories/checkers/Index')
const CategoriesCheckersAdd   = () => import('@/views/categories/checkers/Add')
const CategoriesCheckersView  = () => import('@/views/categories/checkers/View')
const CategoriesCheckersEdit  = () => import('@/views/categories/checkers/Edit')

// Views - Conferences
const ConferencesIndex = () => import('@/views/conferences/Index')
const ConferencesView = () => import('@/views/conferences/View')
const ConferencesCheck = () => import('@/views/conferences/Check')

// Views - Tipos de Edicao
const EditionTypesIndex = () => import('@/views/edition_types/Index')
const EditionTypesAdd = () => import('@/views/edition_types/Add')
const EditionTypesEdit = () => import('@/views/edition_types/Edit')
const EditionTypesView = () => import('@/views/edition_types/View')

// Views - Configuracao - Integracao
const IntegrationIndex = () => import('@/views/configuration/integration/Index');
const IntegrationAdd   = () => import('@/views/configuration/integration/Add');
const IntegrationView  = () => import('@/views/configuration/integration/View');
const IntegrationEdit  = () => import('@/views/configuration/integration/Edit');

// Login
const Login = () => import('@/views/pages/Login')
const ForgotPassword = () => import('@/views/pages/ForgotPassword')
const NewPassword = () => import('@/views/pages/NewPassword')
const Logs = () => import('@/views/logs/Index')

Vue.use(Router)

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    /* ---- Login --- */
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {auth: false}
    },
    /* ---- Login --- */
    {
      path: '/forgotpassword',
      name: 'ForgotPassword',
      component: ForgotPassword,
      meta: {auth: false}
    },
    {
      path: '/newpassword/:token',
      name: 'NewPassword',
      component: NewPassword,
      meta: {auth: false}
    },
    {
      path: '/',
      name: 'Home',
      redirect: '/painel',
      component: Full,
      meta: {auth: true},
      children: [
        {
          path: 'painel',
          name: 'Painel',
          component: Dashboard
        },
        /* ---- Usuários ---- */
        {
          path: 'usuarios',
          name: 'Usuários',
          redirect: '/usuarios/listar',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'listar',
              name: 'Listar Usuários',
              component: UsersIndex
            },
            {
              path: 'adicionar',
              name: 'Novo Usuário',
              component: UsersAdd
            },
            {
              path: 'visualizar/:id',
              name: 'Visualizar',
              component: UsersView
            },
            {
              path: 'editar/:id',
              name: 'Editar',
              component: UsersEdit
            }
          ]
        },
        /* ---- Perfis ---- */
        {
          path: 'perfis',
          name: 'Perfis',
          redirect: '/perfis/listar',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'listar',
              name: 'Listar Perfis',
              component: ProfilesIndex
            },
            {
              path: 'adicionar',
              name: 'Novo Perfil',
              component: ProfilesAdd
            },
            {
              path: 'visualizar',
              name: 'Visualizar Perfil',
              component: ProfilesView
            },
            {
              path: 'editar',
              name: 'Editar Perfil',
              component: ProfilesEdit
            },
            {
              path: 'permissoes',
              name: 'Gerenciar Permissões',
              component: ProfilesPermissions
            }
          ]
        },
        /* ---- Órgãos ---- */
        {
          path: 'orgaos',
          name: 'Órgãos',
          redirect: '/orgaos/listar',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'listar',
              name: 'Listar Órgãos',
              component: AgenciesIndex
            },
            {
              path: 'adicionar',
              name: 'Novo Órgão',
              component: AgenciesAdd
            },
            {
              path: 'visualizar/:id',
              name: 'Visualizar Órgão',
              component: AgenciesView
            },
            {
              path: 'editar/:id',
              name: 'Editar Órgão',
              component: AgenciesEdit
            }
          ]
        },
        /* ---- Matérias ---- */
        {
          path: 'materias',
          name: 'Matérias',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'envio',
              name: 'Envio',
              component: ArticleSubmit
            },
            {
              path: 'proximo_passo/:id',
              name: 'Próximo Passo',
              component: ArticleNextStep
            },
            {
              path: ':status',
              name: 'Últimas Matérias',
              component: Articles,
              exact: true
            },
            {
              path: 'visualizar/:id',
              name: 'Visualizar Matéria',
              component: ArticlesView
            },
            {
              path: 'editar/:id',
              name: 'Editar Matéria',
              component: ArticleSubmit
            }
          ]
        },
        /* ---- Categorias ---- */
        {
          path: 'categorias',
          name: 'Categorias',
          redirect: '/categorias/listar',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'listar',
              name: 'Listar Categorias',
              component: CategoriesIndex
            },
            {
              path: 'adicionar/:id?',
              name: 'Nova Categoria',
              component: CategoriesAdd
            },
            {
              path: 'visualizar/:id',
              name: 'Visualizar Categoria',
              component: CategoriesView
            },
            {
              path: 'editar/:id',
              name: 'Editar Categoria',
              component: CategoriesEdit
            },
            /* ---- Categorias - Redatores ---- */
            {
              path: 'redatores',
              name: 'Redatores',
              redirect: 'redatores/listar',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'listar',
                  name: 'Listar Permissões de Redatores',
                  component: CategoriesEditorsIndex
                },
                {
                  path: 'adicionar',
                  name: 'Redator - Nova Permissão',
                  component: CategoriesEditorsAdd
                },
                {
                  path: 'visualizar/:id',
                  name: 'Redator - Visualizar Permissão',
                  component: CategoriesEditorsView
                },
                {
                  path: 'editar/:id',
                  name: 'Redator - Editar Permissão',
                  component: CategoriesEditorsEdit
                }
              ]
            },
            /* ---- Categorias - Editores ---- */
            {
              path: 'conferentes',
              name: 'Conferentes',
              redirect: 'conferentes/listar',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'listar',
                  name: 'Listar Permissões de Conferentes',
                  component: CategoriesCheckersIndex
                },
                {
                  path: 'adicionar',
                  name: 'Conferente - Nova Permissão',
                  component: CategoriesCheckersAdd
                },
                {
                  path: 'visualizar/:id',
                  name: 'Conferente - Visualizar Permissão',
                  component: CategoriesCheckersView
                },
                {
                  path: 'editar/:id',
                  name: 'Conferente - Editar Permissão',
                  component: CategoriesCheckersEdit
                }
              ]
            }
          ]
        },
        /* ---- Conferência ---- */
        {
          path: 'conferencias',
          name: 'Conferência',
          redirect: '/conferencias/listar',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'listar',
              name: 'Listar Matérias',
              component: ConferencesIndex
            },
            {
              path: 'visualizar/:id',
              name: 'Ver Matéria',
              component: ConferencesView
            },
            {
              path: 'conferir/:id',
              name: 'Conferir Matéria',
              component: ConferencesCheck
            }
          ]
        },
        /* ---- Edição ---- */
        {
          path: 'edicoes',
          name: 'Edição',
          redirect: '/edicoes/listar',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'abrir',
              name: 'Abrir Edição',
              component: EditionOpen
            },
            {
              path: 'visualizar/:id',
              name: 'Visualizar Edição',
              component: EditionView
            },
            {
              path: 'editar/:id',
              name: 'Editar Edição',
              component: EditionEdit
            },
            {
              path: 'listar',
              name: 'Listar Edições',
              component: Editions,
              exact: true
            },
            /* ---- Tipos de Edicao ---- */
            {
              path: 'tipos',
              name: 'Tipos de Edição',
              redirect: '/edicoes/tipos/listar',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'listar',
                  name: 'Listar Tipos de Edição',
                  component: EditionTypesIndex
                },
                {
                  path: 'adicionar',
                  name: 'Adicionar Novo Tipo de Edição',
                  component: EditionTypesAdd
                },
                {
                  path: 'visualizar/:id',
                  name: 'Visualizar Tipo de Edição',
                  component: EditionTypesView
                },
                {
                  path: 'editar/:id',
                  name: 'Editar Tipo de Edição',
                  component: EditionTypesEdit
                }
              ]
            }
          ]
        },
        /* ---- Legislações ---- */
        {
          path: 'legislacoes',
          name: 'Legislações',
          redirect: '/legislacoes/listar',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'listar',
              name: 'Legislações Cadastradas',
              component: LegislationsIndex
            },
            {
              path: 'adicionar',
              name: 'Cadastrar Legislação',
              component: LegislationsAdd
            },
            {
              path: 'visualizar/:id',
              name: 'Visualizar Legislação',
              component: LegislationsView
            },
            {
              path: 'editar/:id',
              name: 'Editar Legislação',
              component: LegislationsEdit
            }
          ]
        },
        /* ---- Configuracao ---- */
        {
          path: 'configuracoes',
          name: 'Configuração',
          redirect: '/configuracoes/listar',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            /* ---- Integração de Sistemas ---- */
            {
              path: 'integracoes',
              name: 'Integracoes',
              redirect: '/configuracoes/integracoes/listar',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'listar',
                  name: 'Listar Integrações',
                  component: IntegrationIndex
                },
                {
                  path: 'adicionar',
                  name: 'Adicionar Integraçáo',
                  component: IntegrationAdd
                },
                {
                  path: 'visualizar/:id',
                  name: 'Visualizar Integraçáo',
                  component: IntegrationView
                },
                {
                  path: 'editar/:id',
                  name: 'Editar Integraçáo',
                  component: IntegrationEdit
                }
              ]
            },
            {
              path: 'logs',
              name: 'Logs do Sistema',
              component: Logs
            },
            {
              path: 'indexacao',
              name: 'Indexação das Edições',
              component: IndexManagement
            }
          ]
        }
      ]
    }
  ]
})
